export default function compactArrayUtil (array) {
  if (!Array.isArray(array)) {
    throw new Error('Expected an array')
  }

  return array.filter(Boolean)
}
